import { useState } from "react"
import Button, {
  type ButtonProps,
} from "@/v2-backoffice-client/components/button"
import CustomerTenantAddSelectorDialog from "@/v2-backoffice-client/customer/tenant/add/CustomerTenantAddSelectorDialog"

export type CustomerTenantAddSelectorDialogButtonProps = ButtonProps & {
  externalCustomerId: string
  customerName?: string
  existingTenantIds?: number[]
}

function CustomerTenantAddSelectorDialogButton(
  props: CustomerTenantAddSelectorDialogButtonProps,
) {
  const {
    externalCustomerId,
    customerName,
    existingTenantIds = [],
    onClick,
    children,
    ...buttonProps
  } = props

  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <Button
        variant="primary"
        size="tiny"
        iconSrc="plus"
        iconSize={10}
        onClick={(e) => {
          setIsOpen(true)
          onClick?.(e)
        }}
        {...buttonProps}
      >
        {children ?? "Add team"}
      </Button>

      <CustomerTenantAddSelectorDialog
        open={isOpen}
        onOpenChange={setIsOpen}
        externalCustomerId={externalCustomerId}
        customerName={customerName}
        existingTenantIds={existingTenantIds}
      />
    </>
  )
}

export default CustomerTenantAddSelectorDialogButton
